/**
 * Created by Victor Rojo on 15/11/17.
 */
import { TRANSLATIONS, TRANSLATIONS_FORMAT, LOCALE_ID, MissingTranslationStrategy } from '@angular/core';
import { CompilerConfig } from '@angular/compiler';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import localeEn from '@angular/common/locales/en';
import localePt from '@angular/common/locales/pt';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { esLocale } from 'ngx-bootstrap/locale';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { ptBrLocale } from 'ngx-bootstrap/locale';

import * as Highcharts from 'highcharts/highstock';

export function getTranslationProviders(): Promise<Object[]> {

  // Get the locale id from the global
  const locale = document['locale'] as string;

  setLocale(locale);
  setHighchartsLang(locale);

  // return no providers if fail to get translation file for locale
  const noProviders: Object[] = [];

  // No locale or U.S. English: no translation providers
  if (!locale || locale === 'en-US') {
    return Promise.resolve(noProviders);
  }

  // Ex: 'locale/messages.es.xlf`
  const translationFile = `./locale/messages.${locale}.xlf`;

  return getTranslations(translationFile)
    .then( (translations: string ) => [
      { provide: TRANSLATIONS, useValue: translations },
      { provide: TRANSLATIONS_FORMAT, useValue: 'xlf' },
      { provide: LOCALE_ID, useValue: locale },
    ])
    .catch(() => noProviders); // ignore if file not found
}

export function setLocale(localeId: string): Promise<any> {
  let locale = localeEn;
  if ( localeId == "es" ) {
    locale = localeEs;
  } else if ( localeId = "pt" ) {
    locale = localePt;
  }
  let ngxLocale = enGbLocale;
  if ( localeId == "es" ) {
    ngxLocale = esLocale;
  } else if ( localeId = "pt" ) {
    ngxLocale = ptBrLocale;
  }
  return new Promise((resolve, reject) => {
    registerLocaleData(locale, localeId);
    defineLocale(localeId, ngxLocale);
    resolve();
  });
}

function getTranslations(file: string) {
  return window['fetch'](file)
    .then(resp => resp.text());
}


function setHighchartsLang(localeId:string) {
  Highcharts.setOptions({
    time: {
        useUTC: false
    }
  });
  if ( localeId == "es" ) {
    Highcharts.setOptions({
      lang: {
        loading: 'Cargando...',
        months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
        weekdays: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
        shortMonths: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
        rangeSelectorFrom: "Desde",
        rangeSelectorTo: "Hasta",
        rangeSelectorZoom: "Período",
        downloadPNG: 'Descargar imagen PNG',
        downloadJPEG: 'Descargar imagen JPEG',
        downloadPDF: 'Descargar imagen PDF',
        downloadSVG: 'Descargar imagen SVG',
        downloadCSV: 'Descargar CSV',
        downloadXLS: 'Descargar XLS',
        printChart: 'Imprimir',
        resetZoom: 'Reiniciar zoom',
        resetZoomTitle: 'Reiniciar zoom',
        viewFullscreen: 'Ver en pantalla completa',
        thousandsSep: ",",
        decimalPoint: '.'
      }
    });
  } else if ( localeId == "pt" ) {
    Highcharts.setOptions({
      lang: {
        loading: 'Carregando...',
        months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
        weekdays: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
        shortMonths: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
        rangeSelectorFrom: "De",
        rangeSelectorTo: "Até",
        rangeSelectorZoom: "Período",
        downloadPNG: 'Baixar imagem PNG',
        downloadJPEG: 'Baixar imagem JPEG',
        downloadPDF: 'Baixar imagem PDF',
        downloadSVG: 'Baixar imagem SVG',
        downloadCSV: 'Baixar CSV',
        downloadXLS: 'Baixar XLS',
        printChart: 'Imprimir',
        resetZoom: 'Reiniciar zoom',
        resetZoomTitle: 'Reiniciar zoom',
        viewFullscreen: 'Ver en ecrã completo',
        thousandsSep: ",",
        decimalPoint: '.'
      }
    });
  }
}
